module.exports = __webpack_public_path__ + "static/media/profilepic.66343e0a.jpg";